import React from "react";

export default function Footer() {
  return (
    <div>
      <footer className="main-footer">
        <strong>
          Copyright © 2022-2023
          <a className="pl-2" style={{ color: "#869099" }}>
            WolfWin.
          </a>
        </strong>
        All rights reserved.
        <div className="float-right d-none d-sm-inline-block">
          <b>Version</b> 1.1.1
        </div>
      </footer>
    </div>
  );
}
